import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Nav, INavStyles, INavLinkGroup, INavLink } from '@fluentui/react/lib/Nav';
import { Text, Stack, IStackStyles, useTheme } from '@fluentui/react';
import { APP_VERSION } from '../../../common/constants';
import { t } from 'i18next';
import { routes } from '../../../common/routes';
import { Usuario } from '../../../system/Usuario/Usuario';
import { isLightTheme } from '../../../App';

const GESTION_CLUB_LINKS: INavLink[] = [
  {
    name: 'Planilla digital',
    url: routes.planilla_partido_programado.route,
    key: 'Planilla digital',
    icon: 'AccountActivity',
  },
  // {
  //   name: 'Planilla offline',
  //   url: routes.planilla_partido_offline.route,
  //   key: 'Planilla offline',
  //   icon: 'OfflineOneDriveParachuteDisabled',
  // },
];

const GESTION_ARBITROS_LINKS: INavLink[] = [
  {
    name: 'Planilla digital',
    url: routes.planilla_partido_programado.route,
    key: 'Planilla digital',
    icon: 'AccountActivity',
  },
  // {
  //   name: 'Planilla offline',
  //   url: routes.planilla_partido_offline.route,
  //   key: 'Planilla offline',
  //   icon: 'OfflineOneDriveParachuteDisabled',
  // },
];

const GESTION_INTERNA_NAME = 'Gestión Interna';
const GESTION_FEDERACION_NAME = 'Gestión Federacion';
const GESTION_CLUB_NAME = 'Gestión Club';
const GESTION_ARBITROS_NAME = 'Gestión Arbitros';

const _navLinkGroups: INavLinkGroup[] = [
  {
    name: GESTION_CLUB_NAME,
    links: GESTION_CLUB_LINKS,
  },
  {
    name: GESTION_ARBITROS_NAME,
    links: GESTION_ARBITROS_LINKS,
  },

  //   ],
  // },
  //
];

interface AppNavProps {
  onLinkClicked?: () => void;
  className?: string;
  user?: Usuario;
  changeTheme: () => void;
}

const AppNav: React.FC<AppNavProps> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const searchScopeInLinksChildren = (links: INavLink[], entities: string[]): boolean => {
    if (props.user) {
      for (const link of links) {
        const route = entities.find((entity) => routes[entity].route === link.url);
        if (route && routes[route].scopes) {
          return props.user.hasScope(routes[route].scopes!);
        }
        if (link.links) {
          const resultadoRecursivo = searchScopeInLinksChildren(link.links, entities);
          if (resultadoRecursivo) {
            return resultadoRecursivo;
          }
        }
      }
    }
    return false;
  };

  const optionsSidebar = React.useMemo((): INavLinkGroup[] => {
    const prepareLinks = (links: INavLink[]): INavLink[] => {
      const entities = Object.keys(routes);

      return links.filter((link) => {
        const route = entities.find((entity) => routes[entity].route === link.url);
        if (route && routes[route].scopes && props.user) {
          return props.user.hasScope(routes[route].scopes!);
        } else if (link.links) {
          link.links = prepareLinks(link.links!);
          return link.links.length > 0;
        } else {
          return false;
        }
      });
    };

    let groups: INavLinkGroup[] = [
      {
        links: [
          {
            name: '',
            url: routes.planilla_partido_programado.route,
            icon: 'Calendar',
            key: 'key8',
            target: '_blank',
            title: 'Partidos',
          },
        ],
      },
    ];

    groups.forEach((group) => {
      group.links = prepareLinks(group.links);
    });

    return groups;
  }, [props.user]);

  const optionsSidebar_old = React.useMemo((): INavLinkGroup[] => {
    const entities = Object.keys(routes);

    let groups: INavLinkGroup[] = [];
    if (props.user) {
      groups = _navLinkGroups.filter((g) => {
        if (props.user?.isClubUser()) {
          if (g.name === GESTION_CLUB_NAME) return true;
        }

        if (props.user?.isFederationUser()) {
          if (g.name === GESTION_CLUB_NAME) return true;
        }

        if (props.user?.isConfederationUser()) {
          if (g.name === GESTION_CLUB_NAME) return true;
          if (g.name === GESTION_ARBITROS_NAME) return true;
        }

        if (props.user?.isArbitroUser()) {
          if (g.name === GESTION_ARBITROS_NAME) return true;
        }

        if (props.user?.isAdminUser()) {
          return true;
        }

        return false;
      });

      groups.forEach((group) => {
        const links = group.links.filter((link) => {
          // return searchScopeInLinksChildren(link.links ? link.links : [], entities);
          const route = entities.find((entity) => routes[entity].route === link.url);
          if (route && routes[route].scopes) {
            return props.user?.hasScope(routes[route].scopes!);
          }
          return true;
        });
        group.links = links;
      });
    }
    return groups;
  }, [props.user]);

  const searchInLinksChildren = (links: INavLink[], key: string): false | string => {
    for (const link of links) {
      if (link.url === key) {
        return String(link.key);
      }
      if (link.links) {
        const resultadoRecursivo = searchInLinksChildren(link.links, key);
        if (resultadoRecursivo) {
          return resultadoRecursivo;
        }
      }
    }
    return false;
  };

  const selectedKey = React.useMemo(() => {
    if (optionsSidebar) {
      const url = new URL(window.location.href);
      const ruta = url.pathname.split('/');
      const primerParametro = '/' + ruta[1];

      let ret = '';

      optionsSidebar.forEach((link) => {
        const keySelected = searchInLinksChildren(link.links, primerParametro);
        if (keySelected) {
          ret = keySelected;
        }
      });
      return ret;
    }
    return '0';
  }, [window.location.href, optionsSidebar, searchInLinksChildren]);

  const onLinkClick = (ev?: React.MouseEvent<HTMLElement, MouseEvent>, item?: INavLink) => {
    ev?.preventDefault();
    if (item) navigate(item.url);
    if (props.onLinkClicked) props.onLinkClicked();
  };
  const theme = useTheme();

  const stackStyles: IStackStyles = {
    root: {
      height: '100%',
      maxHeight: '92vh',
      borderRight: '1px solid ' + theme.palette.neutralQuaternary,
      // overflowY: 'auto',
      overflowX: 'hidden',
      // minWidth: '210px',
      // width: '210px',
    },
  };

  const navStylesWhenNotInPanel: Partial<INavStyles> = {
    root: {
      boxSizing: 'border-box',
      borderRight: '1px solid ' + theme.palette.neutralQuaternary,
      overflowY: 'auto',
      fontSize: 18,
      height: 60,
    },
    link: {
      padding: '13px 10px',
      height: 60,
    },
  };
  const stackSecondNav: IStackStyles = {
    root: {
      height: '100%',
      maxHeight: '12%',
      // overflowY: 'auto',
      overflowX: 'hidden',
      // minWidth: '210px',
      // width: '210px',
    },
  };

  const navSecondStylesWhenNotInPanel: Partial<INavStyles> = {
    root: {
      boxSizing: 'border-box',
      borderRight: '1px solid ' + theme.palette.neutralQuaternary,
      overflowY: 'hidden',
      fontSize: 18,
      height: 60,
    },
    link: {
      padding: '13px 10px',
      height: 60,
    },
  };

  return (
    <Stack verticalFill={true}>
      <Stack.Item grow={3} styles={stackStyles} className="iconized-menu">
        <Nav
          selectedKey={selectedKey}
          ariaLabel="Barra de navegación"
          styles={navStylesWhenNotInPanel}
          groups={optionsSidebar}
          // groups={optionsSidebar_old}
          className={props.className + ' h-inherit '}
          onLinkClick={onLinkClick}
        />
      </Stack.Item>
      <Stack.Item grow={3} styles={stackSecondNav} className="iconized-menu">
        <Nav
          selectedKey={selectedKey}
          ariaLabel="Barra de navegación"
          styles={navSecondStylesWhenNotInPanel}
          groups={[
            {
              links: [
                {
                  name: '',
                  url: '',
                  key: 'theme',
                  isExpanded: true,
                  target: '_blank',
                  icon: isLightTheme(theme) ? 'ClearNight' : 'Sunny',
                  title: 'Tema',
                },
              ],
            },
          ]}
          className={props.className + ' h-inherit '}
          onLinkClick={() => {
            props.changeTheme();
          }}
        />
      </Stack.Item>
    </Stack>
  );
};

export default AppNav;
